import { render } from "./visibility.svg.vue?vue&type=template&id=0ac7773a"
import script from "./visibility.svg.vue?vue&type=script&lang=js"
export * from "./visibility.svg.vue?vue&type=script&lang=js"
script.render = render

export default script